import { getExcludeCertsAndLicenses } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetFlagExcludeCertsAndLicenses = (
  tenantId: string,
  enabled = true
) => {
  const { data, status, refetch } = useQuery(
    ['exclude-certs-and-licenses', tenantId],
    () => getExcludeCertsAndLicenses(tenantId),
    {
      enabled,
    }
  );

  return {
    excludeCertsAndLicenses: data || false,
    excludeCertsAndLicensesStatus: status,
    fetchExcludeCertsAndLicenses: refetch,
  };
};
